import React from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import { Query } from 'react-apollo';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Spin from 'components/common/Spin';
import Button from '@material-ui/core/Button';
import { GET_GROUPS } from 'graphql/groups';
import useStyles from './styles';
import CreateGroup from './create-group';
import GroupCard from './components/GroupCard';
import GroupChat from '../pages/messages/group-chat'
import GroupSMS from '../pages/messages/group-sms'

const Groups = ({}) => {
  const user = useSelector(s => s.user.user);
  return (
    <Box>
      <Switch>
        <Route exact path="/groups/create" component={CreateGroup} />
        <Route path="/groups/messages/:roomId?" component={GroupChat} />
        <Route path="/groups/sms/:groupId?" component={GroupSMS} />
        <Box>
          <Query query={GET_GROUPS} fetchPolicy={'cache-and-network'}>
            {({ data, loading }) => {
              if (loading) return <Spin spinning linear />;

              return (
                <Grid container spacing={3}>
                  {data?.groups?.map((group) => (
                    <Grid item xs={12} md={6} lg={4} xl={3}>
                      <GroupCard group={group} key={group.id} />
                    </Grid>
                  ))}
                </Grid>
              );
            }}
          </Query>
          { user.type === 'admin' && (
            <Box textAlign="center" padding={3}>
              <Button
                component={Link}
                to="/groups/create"
                variant="outlined"
                color="primary"
                size="large"
              >
                Create Group
              </Button>
            </Box>
          )}
        </Box>
      </Switch>
    </Box>
  );
};

export default Groups;
